module.exports = __webpack_public_path__ + "img/slim.5c6a4184.png";